import { useRef } from 'react';
import { hash } from '../utils';
const createHash = (widget, data = {}, id) => {
    if (id)
        return id;
    if (data)
        return hash(`${widget}:${JSON.stringify(data)}`);
    return hash(`${widget}:${Date.now}-${Math.random()}}`);
};
/**
 * Генерирует идентификатор для компонента Remote
 * @param widget
 * @param data
 * @param id
 */
export function useId(widget, data = {}, id) {
    const usedIdentifier = useRef();
    if (!usedIdentifier.current) {
        usedIdentifier.current = createHash(widget, data, id);
    }
    return usedIdentifier.current;
}
